module.exports = __webpack_public_path__ + "static/media/2@2x.6367621f.png";